// extracted by mini-css-extract-plugin
module.exports = {"faqBgWrapper":"_112vf","faqWrapper":"_3QXAY","override":"_1beHJ"};